import "./HealthLocker.css";

import { Col, Dropdown, Grid, Modal, Row } from "react-bootstrap";
import React, { Component } from "react";

import Constants from "../../../Phi/Constants";
import FilePreview from "./FilePreviewPopup";
import HSGFilePreview from  "./HSGFilePreview"
import PDFIcon from "../../../Assets/pdf_icon.png";
import UploadPopup from "./UploadDocumentPopup";
import moment from "moment";

const imagePreviewArray = ["image/jpeg", "image/png"];
const pdfPreviewArray = ["application/pdf"];
const docPreviewArray = ["application/msword"];

class HsgToggle extends Component {
    constructor(props) {
        super(props);

        this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    render() {
        return (
            <div
                className="hsg-header-health-locker-root"
                bsrole={this.props.bsRole || "toggle"}
                onClick={this.handleToggleClick}
            >
                {this.props.children}
            </div>
        );
    }

    handleToggleClick(e) {
        e.preventDefault();

        this.props.onClick(e);
    }
}

class HsgMenu extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return <div className="dropdown-menu hsg-hl-alert-menu">{this.props.children}</div>;
    }
}

class HealthLocker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUploadPopup: false,
            showDocPreview: false,
            currentDocumentURL: null,
            currentDocumentType: null,
            currentDocument: {},

            showAllDocuments: {},
            showConfirmationModal: null,

            currentActiveView: "list",

            showDropdown: {},
        };
    }

    componentWillMount() {
        this.props.contentNode && this.props.fetchHealthLocker(this.props.contentNode, this.props.documentGroup);
    }

    componentDidMount() {
        this.props.contentNode && this.props.fetchHealthLocker(this.props.contentNode, this.props.documentGroup);
    }

    generatePayload(contentNode) {
        return {
            inOrganizationCustomJson: {schoolContentID: contentNode}
        };
    }

    generateStudentPayload(studentContentId, child) {
        const payload = {
            hsgId: child.uuid,
            currentUserId: this.props.userId,
            description: "Adding Content Node In Student"
        };

        const custom = {
            studentContentNodeId: studentContentId
        };

        payload.newCustom = JSON.stringify(custom);

        return payload;
    }

    // handeOrgDetailsChange = (data) => {
    //     const schoolContactPersonDetail = {
    //         ...this.props.schoolContactPersonDetails[0],
    //         contactNo: data.contactNo
    //     }
    //     let dataToSend = {
    //         ...data,
    //         schoolContactPersonDetails: this.props.schoolContactPersonDetails.length > 1 ? [
    //             schoolContactPersonDetail,
    //             this.props.schoolContactPersonDetails.slice(1)
    //         ] : [schoolContactPersonDetail]
    //     }
    //     delete dataToSend.emailId
    //     delete dataToSend.contactNo
    //     this.props.updateOrganization(this.props.inOrganizationId, dataToSend)
    //     history.replace('/dashboard')
    // }

    componentWillReceiveProps(nextProps) {
        if (this.props.needToUpdate && this.props.contentNode !== nextProps.contentNode) {
            !!!nextProps.isStudent && this.props.saveSchoolContentNode(this.props.organizationId, this.generatePayload(nextProps.contentNode));
        }

        if(this.props.needToUpdate && this.props.contentNode !== nextProps.contentNode && this.props.studentProfile && this.props.studentProfile.uuid === nextProps.studentProfile.uuid) {
            this.props.saveStudentContentNode(this.generatePayload(nextProps.studentContentId, nextProps.child));
            nextProps.isStudent && this.props.saveStudentContentNode(this.generateStudentPayload(nextProps.contentNode, nextProps.studentProfile));
        }

        if (this.props.contentNode !== nextProps.contentNode) {
            // nextProps.isStudent && this.props.saveSchoolContentNode(this.generatePayload(nextProps.contentNode));
            this.props.fetchHealthLocker(nextProps.contentNode, this.props.documentGroup);
        }
    }

    callRemoveDoc = document => {
        this.props.removeDocuments(
            document.id,
            document.uuid,
            this.props.contentNode,
            document.type,
            this.props.documentGroup
        );
        this.setState({ showConfirmationModal: false });
    };

    _renderConfirmationModal = () => (
        <Modal show={this.state.showConfirmationModal} onHide={() => this.setState({ showConfirmationModal: false })}>
            <Modal.Header>
                <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {/* Please confirm removal of{" "}
                    {(this.state.currentDeletionDocument && this.state.currentDeletionDocument.docMeta.file_name) ||
                        "this document"}
                    .{" "} */}
                    Please make sure this is a legit action. Doing this will permanently delete your data along with documents and you will not be able to recover that.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <button className="hsg-btn-white" onClick={() => this.setState({ showConfirmationModal: false })}>
                    No
                </button>
                <button className="hsg-btn" onClick={() => this.callRemoveDoc(this.state.currentDeletionDocument)}>
                    Yes
                </button>
            </Modal.Footer>
        </Modal>
    );

    togglePreview = flag => {
        this.setState({ showDocPreview: flag, currentDocumentURL: null, currentDocumentType: null, currentDocument: {}, currentDocumentGroup: null });
    };

    _renderImageThumb = document =>
        imagePreviewArray.includes(document.mimeType) ? (
            <img className="hsg-health-locker-thumbnail" src={document.contentUrl} />
        ) : pdfPreviewArray.includes(document.mimeType) ? (
            <img className="hsg-health-locker-thumbnail" src={PDFIcon} />
        ) : docPreviewArray.includes(document.mimeType) ? (
            <img className="hsg-health-locker-thumbnail" src={PDFIcon} />
        ) : (
            <img className="hsg-health-locker-thumbnail" src={PDFIcon} />
        );

    closeOnBlur = (element) => {
        this.setState({ [element]: false });
    };

    getDropDown = (document, index, pos) => {
        let elementId = `toggle-hsg-health-burger-dropdown-${index}-${pos}`;

        return (
            <div className="no-focus-outline" onBlur={() => this.closeOnBlur(elementId)} tabIndex="0">
                <Dropdown
                    id={elementId}
                    open={this.state.showDropdown[`hsg-health-burger-dropdown-${index}`]}
                    open={this.state[elementId]}
                    onToggle={() =>
                        this.setState({ [elementId]: !!!this.state[elementId] })
                    }
                >
                    <HsgToggle bsRole="toggle">
                        <span className="glyphicon glyphicon-option-vertical" />
                    </HsgToggle>

                    <HsgMenu bsRole="menu">
                        <div key={index}>
                            <div
                                className="hsg-hl-dropdown-menu-option"
                                onClick={() => window.open(document.contentUrl, "_blank")}
                            >
                                Open
                            </div>
                            <div
                                className="hsg-hl-dropdown-menu-option"
                                onClick={() => window.open(document.contentUrl, "_blank")}
                                key={index}
                            >
                                Download
                            </div>
                            {document.type === Constants.documentCategories.SchoolHealthLocker
                               && this.props.roleType !=19
                               && !!!this.props.blockEdit && (
                                    <div
                                        className="hsg-hl-dropdown-menu-option"
                                        onClick={() =>
                                            this.setState({
                                                showConfirmationModal: true,
                                                currentDeletionDocument: document
                                            })
                                        }
                                    >
                                        Remove
                                    </div>
                                )}
                        </div>
                    </HsgMenu>
                </Dropdown>
            </div>
        );
    };

    getDocumentName = document => (
        document && document.docMeta ?
        <div className="image-trimed-name">
            {typeof document.subType === "string"
                ? Constants.documentSubCategoryLabel[document.subType] || document.subType
                : document.fileName}
        </div> : null
    );

    getDocumentInformation = document => {

        let meta = document.docMeta || {}
        let name = meta.file_name
        let type = meta.subType
        let condition = meta.condition
        let uploaded = document.uploaded ? moment(document.uploaded).format(Constants.defaultDateFormat) : null

        let startedOn = meta.startedOn ? moment(meta.startedOn).format(Constants.defaultDateFormat) : null
        let endedOn = meta.endedOn ? moment(meta.endedOn).format(Constants.defaultDateFormat) : null

        return (
            <div className="image-trim-name" style={{verticalAlign: "middle", marginTop: 3}}>
                {condition && <div className="col-xs-12 no-padding">
                    <div className="col-xs-4 no-padding hidden-xs">
                        Condition:
                    </div>
                    <div className="col-xs-12 col-sm-8 no-padding image-trimed-name">
                        {condition}
                    </div>                
                </div>}
                {type && <div className="col-xs-12 no-padding">
                    <div className="col-xs-4 no-padding hidden-xs">
                        Type:
                    </div>
                    <div className="col-xs-12 col-sm-8 no-padding image-trimed-name">
                        {Constants.documentSubCategoryLabel[document.subType] || document.subType}
                    </div>                
                </div>}
                {/* {name && <div className="col-xs-12 no-padding">
                    <div className="col-xs-4 no-padding hidden-xs">
                        File Name:
                    </div>
                    <div className="col-xs-12 col-sm-8 no-padding image-trim-name">
                        {name}
                    </div>
                </div>} */}
                {uploaded && <div className="col-xs-12 no-padding">
                    <div className="col-xs-4 no-padding hidden-xs">
                        Uploaded On:
                    </div>
                    <div className="col-xs-12 col-sm-8 no-padding image-trimed-name">
                        {uploaded}
                    </div>                
                </div>}
                <div>
                    {startedOn && <div className="col-xs-12 no-padding">
                        <div className="col-xs-4 no-padding hidden-xs">
                            Started On:
                        </div>
                        <div className="col-xs-12 col-sm-8 no-padding image-trimed-name">
                            {startedOn}
                        </div>                
                    </div>}
                    {endedOn && <div className="col-xs-12 no-padding">
                        <div className="col-xs-4 no-padding hidden-xs">
                            ended On:
                        </div>
                        <div className="col-xs-12 col-sm-8 no-padding image-trimed-name">
                            {endedOn}
                        </div>                
                    </div>}
                </div>
            </div> 
        )
    }

    _renderGridView = (document, index, pos) => (
        <div
            className="col-lg-2 col-md-2 col-sm-6 col-xs-8 document-front"
            key={`${index}-${pos}`}
            style={{ padding: 0 }}
        >
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ textAlign: "center" }}>
                <div
                    className="col-lg-11 col-md-11 col-sm-11 col-xs-11 hsg-health-locker-doc-view"
                    onClick={() =>
                        this.setState({
                            showDocPreview: true,
                            currentDocumentURL: document.contentUrl,
                            currentDocumentType: document.mimeType,
                            currentDocumentGroup: document.type,
                            currentDocument: document
                        })
                    }
                    style={{ cursor: "pointer" }}
                >
                    {this._renderImageThumb(document)}
                </div>
                <div className="row col-lg-1 col-md-1 col-sm-1 col-xs-1">
                    {/* <span
                        aria-hidden="true"
                        data-icon="&#e90b;"
                        className="icon-close hsg-icon-close"
                        onClick={() =>
                            this.setState({ showConfirmationModal: true, currentDeletionDocument: document })
                        }
                    ></span> */}
                    {this.getDropDown(document, index, pos)}
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-doc-info">
                {this.getDocumentName(document)}
                <p style={{ fontSize: 10 }}>{`Date: ${moment(document.uploaded.toLocaleDateString()).format(Constants.defaultDateFormat)}`}</p>
            </div>
        </div>
    );

    _renderListView = (document, index, pos) => (
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" key={`${index}-${pos}`}>
            <div
                className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-add-school-upload-doc-after"
                style={{ padding: 3 }}
            >
                <div
                    className="col-lg-11 col-md-11 col-sm-10 col-xs-10 no-padding"
                    onClick={() =>
                        this.setState({
                            showDocPreview: true,
                            currentDocumentURL: document.contentUrl,
                            currentDocumentType: document.mimeType,
                            currentDocumentGroup: document.type,
                            currentDocument: document
                        })
                    }
                    style={{ cursor: "pointer", verticalAlign: "middle" }}
                >
                    <div>
                        <div
                            className="col-lg-3 col-md-3 col-sm-4 col-xs-4 no-padding"
                            style={{ height: 60, width: 60 }}
                        >
                            {this._renderImageThumb(document)}
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-9 col-xs-8 no-padding-right">
                            {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding image-trimed-name">
                                {this.getDocumentName(document)}
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                                <div>{`Date: ${moment(document.uploaded.toLocaleDateString()).format(Constants.defaultDateFormat)}`}</div>
                            </div> */}
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                                {this.getDocumentInformation(document)}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="col-lg-1 col-md-1 col-sm-1 col-xs-2"
                    style={{ textAlign: "right" }}
                >
                    {/* <span
                        aria-hidden="true"
                        data-icon="&#e90b;"
                        className="icon-close"
                        style = {{cursor: "pointer"}}
                        onClick={() =>
                            this.setState({ showConfirmationModal: true, currentDeletionDocument: document })
                        }
                    ></span> */}
                    {this.getDropDown(document, index, pos)}
                </div>
            </div>
        </div>
    );

    _renderDocuments = (props, state) =>
        props.contentNode && props.documentTypes && props.documentTypes.length ? (
            props.documentTypes.map((docType, index) =>
                docType.key === Constants.documentCategories.SchoolHealthLocker || props.isStudent ? (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={index}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 doc-type-heading">
                            <span
                                className={
                                    !!!state.showAllDocuments[docType.key]
                                        ? "glyphicon glyphicon-minus"
                                        : "glyphicon glyphicon-plus"
                                }
                                onClick={() =>
                                    this.setState({
                                        showAllDocuments: {
                                            ...state.showAllDocuments,
                                            [docType.key]: !!!state.showAllDocuments[docType.key]
                                        }
                                    })
                                }
                                style={{ cursor: "pointer" }}
                            />
                            &nbsp;
                            {`${docType.label} (${props.documents[docType.key] &&
                                props.documents[docType.key].length})`}
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 doc-type-body">
                            {!!!state.showAllDocuments[docType.key] && props.documents[docType.key]
                                ? props.documents[docType.key].map((document, pos) =>
                                      this.state.currentActiveView === "grid"
                                          ? this._renderGridView(document, index, pos)
                                          : this._renderListView(document, index, pos)
                                  )
                                : null}
                        </div>
                    </div>
                ) : null
            )
        ) : (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 doc-type-heading" style={{ textAlign: "center" }}>
                No Data Uploaded Yet!.
            </div>
        );

    
    uploadDocuments = (fileObj, contentId, category, fileGroup, fileCustom) => {
        this.props.uploadDocuments(fileObj, contentId, category, fileGroup, fileCustom, this.props.studentProfile && this.props.studentProfile.uuid)
        // this.props.contentNode && this.props.fetchHealthLocker(this.props.contentNode, this.props.documentGroup);
    }

    _renderUploadPopup = (props, state) => (
        <UploadPopup
            show={state.showUploadPopup}
            onHide={() => this.setState({ showUploadPopup: false })}
            header={"Upload Document"}
            bsSize={null}
            contentId={props.contentNode}
            category={props.isStudent ? Constants.documentCategories.StudentMedicalLeave : Constants.documentCategories.SchoolHealthLocker}
            subCategory={null}
            group={props.isStudent ? Constants.documentCategories.StudentHealthLocker : Constants.documentCategories.SchoolHealthLocker}
            uploadDocuments={(fileObj, contentId, category, fileGroup, fileCustom) =>
                this.uploadDocuments(fileObj, contentId, category, fileGroup, fileCustom)
            }
            isMultipleUpload={true}
            allowUserToView={true}
            // hideRemarks={props.isStudent}
            isForMedicalLeave={props.isStudent}
        />
    );

    _renderFilePreview = (props, state) => (
        <FilePreview
            show={state.showDocPreview}
            onHide={() => this.setState({ showDocPreview: false })}
            header={"Upload Document"}
            bsSize={"large"}
            image={this.state.currentDocumentURL}
            type={this.state.currentDocumentType}
            meta={this.state.currentDocument}
            getDocumentName={(currentDocument) => this.getDocumentName(currentDocument)}
        />
    );

    // _renderHSGFilePreview = () => {
    //     const imageArr = docs.map((doc, i) => {
    //         const docInfo = JSON.parse(doc.custom_field)[0]
       
    //         return {
    //             imageUrl: docInfo.json_value.content_url,
    //             type: docInfo.json_value.mimeType,
    //             name: docInfo.json_value.file_name,
    //             id: doc.id,
    //             uuid: doc.uuid
    //         }
    //     })

    //     return <FilePreview 
    //     imgUrl={imageArr}
    //     removeDoc={this.removeDoc}
    //     showFlag={this.props.showFlag}
    //     fileGroup="carebox"
    //     togglePreview={this.togglePreview}
    //     isOpen={this.state.showDocPreview}
    //     />
    // }

    _renderHSGFilePreview = (props, state) => {

        const { documents } = this.props
        const { currentDocument, currentDocumentType, currentDocumentGroup } = this.state
        let allDocument = documents[currentDocumentGroup]

        // { 
        //     imageUrl: this.state.currentDocumentURL,
        //     type: this.state.currentDocumentType,
        //     name: '',
        //     id: 1,
        //     uuid: '123'
        // }

        const isEqual = (a, b) => a === b;
        let cIndex = allDocument && allDocument.length && allDocument.findIndex((item) => isEqual(item.id, currentDocument.id)) || 0
        // cIndex = allDocument && allDocument.length && currentDocument && allDocument.indexOf(currentDocument)

        return (
            currentDocumentType && currentDocumentGroup &&
            <HSGFilePreview

                imgUrl={allDocument}
                photoIndex={cIndex}
                removeDoc={this.removeDoc}
                showFlag={this.props.showDocPreview}
                fileGroup=""
                togglePreview={() => this.setState({ showDocPreview: false })}
                isOpen={state.showDocPreview}
                currentDocument={this.state.currentDocument}
                // show={state.showDocPreview}
                // onHide={() => this.setState({ showDocPreview: false })}
                // header={"Upload Document"}
                // bsSize={"large"}
                // image={this.state.currentDocumentURL}
                // type={this.state.currentDocumentType}
                // meta={this.state.currentDocument}
                // getDocumentName={(currentDocument) => this.getDocumentName(currentDocument)}
            />
        )
    };

    render() {
        const { props, state } = this;

        return (
            <div
                className={props.asSubContainer ? "hsg-health-background" : "hsg-health-background container"}
                style={{ paddingTop: 20, minHeight: (this.props.dim && this.props.dim.height) || 100 }}
            >
                <Grid fluid>
                    <Row className="show-grid">
                        <Col md={12} lg={12} sm={12} xs={12} style={{ padding: 0 }}>
                            <div className="on-right col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {/* <Glyphicon
                                    className={
                                        this.state.currentActiveView === "list"
                                            ? "choice-btn-active"
                                            : "choice-btn-active"
                                    }
                                    glyph="th-list"
                                    onClick={() => this.setState({ currentActiveView: "list" })}
                                />
                                <Glyphicon
                                    className={
                                        this.state.currentActiveView === "grid"
                                            ? "choice-btn-active"
                                            : "choice-btn-active"
                                    }
                                    glyph="th"
                                    onClick={() => this.setState({ currentActiveView: "grid" })}
                                /> */}
                                {!!!props.hideUpload &&  Constants.userPermissionMap[props.roleType] && Constants.userPermissionMap[props.roleType].includes(Constants.userPermissionId.EDIT) ? (
                                    <button
                                        className="hsg-btn"
                                        onClick={() => this.setState({ showUploadPopup: true })}
                                    >
                                        {props.isStudent ? 'Upload leave certificate': 'Upload'}
                                    </button>
                                ) : null}
                            </div>

                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ marginTop: 10, marginBottom:100 }}>
                                {this._renderDocuments(props, state)}
                            </div>
                        </Col>

                        {this._renderUploadPopup(props, state)}
                        {this._renderHSGFilePreview(props, state)}
                        {this._renderConfirmationModal()}
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default HealthLocker;



// WEBPACK FOOTER //
// ./src/Containers/HealthLockerContainer/Component/HealthLocker.js